import { AppError, type RestResponse } from "@artisancode/types";

/** The server's own message for a failed request (e.g. "Stok di bar kurang…"), not "HTTP 400". */
export function getErrorMessage(
  error: unknown,
  fallback = "Gagal menyimpan data.",
): string {
  if (error instanceof AppError) {
    const data = error.data as RestResponse | undefined;
    return data?.errors?.[0]?.message ?? data?.message ?? fallback;
  }
  return error instanceof Error && error.message ? error.message : fallback;
}
